import React from 'react';
import { usePermissoes } from '../hooks/usePermissoes';
import AvisoSemPermissao from './AvisoSemPermissao';
import { fraseDaPermissao } from '../utils/catalogoDePermissoes';

/**
 * Guarda de tela: só desenha o conteúdo se o perfil tiver a permissão.
 *
 * Fica na definição da rota para que a proteção alcance também quem chega pela
 * URL direta, e não apenas quem clica no menu. E, como lê o estado das
 * permissões, uma permissão retirada enquanto a pessoa está com a tela aberta
 * troca o conteúdo pelo aviso na hora, sem esperar um recarregamento.
 */
const Exige: React.FC<{ modulo: string; acao: string; children: React.ReactNode }> = ({
  modulo, acao, children,
}) => {
  const { pode } = usePermissoes();

  if (pode(modulo, acao)) {
    return <>{children}</>;
  }

  return (
    <AvisoSemPermissao
      erro={null}
      alternativa={`Seu perfil não tem permissão para ${fraseDaPermissao(modulo, acao)}.`}
    />
  );
};

export default Exige;
